import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConsultNowSettingContent from '../components/pages/waiting-area/consult-now/content';

const ConsultNowSettingPage = (props) => {
  const showConsultNowSettingModal = useSelector((state) => state.modalReducer.showConsultNowSettingModal);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin);
  const dispatch = useDispatch();

  return (
    <>
      <div>
        <ConsultNowSettingContent
          showConsultNowSettingModal={showConsultNowSettingModal}
          waitingArea={props.waitingArea}
          isConsultNowEnabled={props.isConsultNowEnabled}
          updateOrView={props.updateOrView}
          isAdmin={isAdmin}
          dispatch={dispatch}
        />
      </div>
    </>
  );
};

export default ConsultNowSettingPage;
